<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>签到记录列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">会员：</el-text>
				<el-col :span="21" style="overflow:hidden; line-height:30px;">
          <el-select v-model="subData.userId" style="width:400px;" placeholder="请选择">
            <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            </el-option>
					</el-select>   
				</el-col>
			</el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">签到时间：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入签到时间" style="width:400px;" v-model="subData.signTime"></el-input>
        </el-col>
      </el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		userId : '',
		signTime : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/Signs/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/Signs/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/SignsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>